<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/home'}">Dialnet S.A.</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; Desarrollado y Diseñado por
        <a href="https://aplicacionescorporativas.com" target="_blank">aplicacionescorporativas.com</a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
